module.exports = {"341181002":"天长街道","341181100":"铜城镇","341181101":"汊涧镇","341181102":"秦栏镇","341181103":"大通镇","341181104":"杨村镇","341181105":"石梁镇","341181106":"金集镇","341181107":"永丰镇","341181108":"仁和集镇","341181109":"冶山镇","341181110":"郑集镇","341181111":"张铺镇","341181112":"新街镇","341181113":"万寿镇","341181500":"安徽省大圹圩农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341181.json
// module id = 1027
// module chunks = 0